import {
  Youtube, Github, Globe, FileText, Instagram, Image as ImageIcon,
  Lightbulb, Newspaper, Pin,
} from "lucide-react";

export const SOURCE_META = {
  youtube: { label: "YouTube", icon: Youtube, color: "#FF0000" },
  github: { label: "GitHub", icon: Github, color: "#24292F" },
  paper: { label: "Research", icon: FileText, color: "#1E40AF" },
  instagram: { label: "Instagram", icon: Instagram, color: "#E1306C" },
  pinterest: { label: "Pinterest", icon: Pin, color: "#E60023" },
  article: { label: "Article", icon: Newspaper, color: "#0F766E" },
  website: { label: "Website", icon: Globe, color: "#3B82F6" },
  image: { label: "Image", icon: ImageIcon, color: "#7C3AED" },
  idea: { label: "Idea", icon: Lightbulb, color: "#D97706" },
};

export const SOURCE_ORDER = [
  "article", "youtube", "paper", "website", "github", "instagram", "pinterest", "image", "idea",
];

export const GRADIENTS = [
  "from-[#1E40AF] to-[#3B82F6]",
  "from-[#0F766E] to-[#14B8A6]",
  "from-[#7C3AED] to-[#C084FC]",
  "from-[#D97706] to-[#F59E0B]",
  "from-[#BE123C] to-[#FB7185]",
  "from-[#1C1917] to-[#57534E]",
];

export function gradientFor(id) {
  let h = 0;
  for (let i = 0; i < (id || "").length; i++) h = (h * 31 + id.charCodeAt(i)) >>> 0;
  return GRADIENTS[h % GRADIENTS.length];
}
